var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 17,
    viewBox: "0 0 51 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.29541,
    y: 1.20508,
    width: 49,
    height: 15,
    rx: 7.5,
    fill: "transparent",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2808 12.7051H21.4008L16.6488 6.62208V12.7051H15.6258V4.89508H16.5168L21.2688 10.9781V4.89508H22.2808V12.7051ZM26.5395 12.8151C25.6962 12.8151 25.0105 12.5437 24.4825 12.0011C23.9545 11.4584 23.6905 10.7764 23.6905 9.95508C23.6905 9.14108 23.9582 8.46274 24.4935 7.92008C25.0288 7.37008 25.7145 7.09508 26.5505 7.09508C27.2912 7.09508 27.9108 7.34441 28.4095 7.84308C28.9155 8.33441 29.1685 9.00541 29.1685 9.85608C29.1685 9.96608 29.1648 10.0614 29.1575 10.1421H24.6475C24.6622 10.6554 24.8455 11.0844 25.1975 11.4291C25.5568 11.7737 26.0078 11.9461 26.5505 11.9461C27.3205 11.9461 27.8925 11.6271 28.2665 10.9891L29.0145 11.5061C28.4792 12.3787 27.6542 12.8151 26.5395 12.8151ZM24.7135 9.37208H28.2005C28.1272 8.93208 27.9328 8.58374 27.6175 8.32708C27.3095 8.06308 26.9428 7.93108 26.5175 7.93108C26.0848 7.93108 25.6962 8.06308 25.3515 8.32708C25.0142 8.58374 24.8015 8.93208 24.7135 9.37208ZM35.1644 12.7051L33.8004 8.75608L32.4474 12.7051H31.6114L29.7414 7.20508H30.7314L32.0624 11.2201L33.4374 7.20508H34.1634L35.5384 11.2201L36.8694 7.20508H37.8704L36.0004 12.7051H35.1644Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new-icon.6f9c347d.svg";
export { ForwardRef as ReactComponent };